import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Layout, Descriptions, Button, Spin, Divider, Modal, Tag } from 'antd';
import {
  EditFilled,
  DeleteFilled,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { get, deleted } from '../redux/actions/contratoActions';
import { get as getAlquiler } from '../redux/actions/alquilerActions';
import ContratoEditor from './ContratoEditor';
import ContratoCuotaList from './ContratoCuotaList';
import { callStatus } from '../utils/constants';
import { withRouter } from 'react-router-dom';
import { setBreadcrumbTitle } from '../redux/actions/uiActions';
import dayjs from 'dayjs';
import CustomCellRender from './base/CustomCellRender';

const { Header, Content } = Layout;
const { confirm } = Modal;

const ContratoViewer = ({ dispatch, stateData, parent, match, contratoId }) => {
  const id = match.params.id;
  const id2 = match.params.id2;
  const id3 = contratoId || match.params.id3;
  const [showEdit, setShowEdit] = useState(false);

  const handleHideEditor = () => {
    setShowEdit(false);
  };

  const handleDelete = () => {
    dispatch(deleted(id3)).then(() => {
      dispatch(getAlquiler(id2));
    });
  };

  const handleConfirm = () => {
    confirm({
      title: 'Está a punto de eliminar el contrato, ¿desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sí',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete();
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    dispatch(get(id3));
    if (id2) {
      dispatch(getAlquiler(id2));
    }
  }, [id3, id2, dispatch]);

  useEffect(() => {
    if (
      stateData.object.status === callStatus.OBJECT_SUCCESS ||
      stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS
    ) {
      dispatch(
        setBreadcrumbTitle(
          `/campanas/${id}/alquileres/${id2}/contratos/${id3}`,
          `${stateData.object.data.numero}`
        )
      );
    }
  }, [stateData.object.status, stateData.object.data, dispatch, id, id2, id3]);

  const data = stateData.object.data;
  const loading = stateData.object.status === callStatus.OBJECT_IN_PROCESS;

  return (
    <Layout style={{ height: '100%' }}>
      <Header
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          marginTop: '5px',
          marginBottom: '10px',
          height: 'auto',
          minHeight: '50px',
          backgroundColor: 'transparent',
          padding: 0,
        }}
      >
        <Spin spinning={loading}>
          {(stateData.object.status === callStatus.OBJECT_SUCCESS ||
            stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS ||
            stateData.object.status === callStatus.OBJECT_FAILED ||
            stateData.object.status === callStatus.OBJECT_IN_PROCESS) &&
            data &&
            data.id && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  height: '100%',
                }}
              >
                <Descriptions
                  bordered
                  size="small"
                  column={4}
                  style={{ marginBottom: 20, flex: 1, marginRight: 20 }}
                >
                  <Descriptions.Item label="Número">
                    {data.numero}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fecha">
                    {data.fecha ? dayjs(data.fecha).format('DD/MM/YYYY') : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Aportante">
                    {parent?.object?.data?.contrato_unico &&
                    data.contrato_inversores?.length > 0 ? (
                      <>
                        {data.contrato_inversores.map((inv) => (
                          <Tag color="blue" key={inv.inversor_id}>
                            {inv.inversor?.nombre || data.inversor_nombre} (
                            {inv.porcentaje}%)
                          </Tag>
                        ))}
                      </>
                    ) : (
                      data.inversor_nombre
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Modalidad Pago">
                    {data.forma_pago_nombre}
                  </Descriptions.Item>
                  {!parent?.object?.data?.contrato_unico && (
                    <Descriptions.Item label="Propietario">
                      {data.alquiler_propietario?.propietario?.nombre}
                    </Descriptions.Item>
                  )}
                  {data.forma_pago_id !== 1 && (
                    <>
                      <Descriptions.Item label="Superficie Ha">
                        <CustomCellRender
                          text={data.superficie}
                          justify="flex-start"
                          prefix=""
                        />
                      </Descriptions.Item>
                      <Descriptions.Item label="Toneladas">
                        <CustomCellRender
                          text={data.toneladas}
                          justify="flex-start"
                          prefix=""
                        />
                      </Descriptions.Item>
                      <Descriptions.Item label="Total Toneladas">
                        <CustomCellRender
                          text={data.toneladas_total}
                          justify="flex-start"
                          prefix=""
                        />
                      </Descriptions.Item>
                      <Descriptions.Item label="Dólar" span={2}>
                        <CustomCellRender
                          text={data.dolar}
                          justify="flex-start"
                          prefix=""
                        />
                      </Descriptions.Item>
                    </>
                  )}
                  {data.forma_pago_id === 1 && (
                    <Descriptions.Item label="Importe U$D" span={2}>
                      <CustomCellRender
                        text={data.importe}
                        justify="flex-start"
                        prefix=""
                      />
                    </Descriptions.Item>
                  )}
                </Descriptions>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <Button
                    icon={<EditFilled />}
                    onClick={() => setShowEdit(true)}
                    type="primary"
                    size="small"
                  >
                    Editar
                  </Button>
                  {contratoId && (
                    <Button
                      icon={<DeleteFilled />}
                      onClick={handleConfirm}
                      danger
                      size="small"
                    >
                      Eliminar
                    </Button>
                  )}
                </div>
              </div>
            )}
        </Spin>
      </Header>
      <Content>
        <div
          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <Divider
            orientation="left"
            style={{ margin: '0 0 10px 0', flexShrink: 0 }}
          >
            Cuotas
          </Divider>
          <div style={{ flex: 1, minHeight: 0 }}>
            <ContratoCuotaList contratoId={id3} />
          </div>
        </div>
      </Content>
      {showEdit && (
        <ContratoEditor
          id={id3}
          parentId={id2}
          onCancel={handleHideEditor}
          visible={true}
        />
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { contrato, alquiler } = state;
  const stateData = contrato;
  const parent = alquiler;
  return {
    stateData,
    parent,
  };
};

export default connect(mapStateToProps)(withRouter(ContratoViewer));
